const Constants = {
  meetings: {
    statuses: {
      STATUS_PLANNED:         10,
      STATUS_WAITING_RESULTS: 20,
      STATUS_RESULTS_DONE:    30,
      STATUS_MISSED:          40,
      STATUS_CANCELED:        50,
    },
    statusesSelectOptions: [
      { id: 10,         name: 'Запланирована' },
      { id: 20, name: 'Ожидает итогов' },
      { id: 30,    name: 'Подведены итоги' },
      { id: 40,          name: 'Пропущена' },
      { id: 50,          name: 'Отменена' },
    ],
    statusTypes: {
      10:         '',
      20: 'warning',
      30:    'success',
      40:          'danger',
    },


    types: {
      TYPE_REGULAR:    1,
      TYPE_ESCALATION: 2,
      TYPE_FEEDBACK:   3,
      TYPE_DEVELOPMENT:4,
    },
    typeSelectOptions: [
      { id: 1,     name: 'Регулярная' },
      { id: 2,  name: 'Эскалация' },
      { id: 3,    name: 'Обратная связь' },
      { id: 4, name: 'Развитие' },
    ],


    formats: {
      FORMAT_OFFLINE: 1,
      FORMAT_ONLINE:  2,
    },
    formatSelectOptions: [
      { id: 1, name: 'Офлайн' },
      { id: 2,  name: 'Онлайн' },
    ],


    modeSelectOptions: [
      { id: '',            name: 'Все' },
      { id: 'initiator',   name: 'Я инициатор' },
      { id: 'participant', name: 'Я участник' },
    ],
  },
};

export default {
  install(Vue) {
    Vue.prototype.$oneToOneConstants = Constants;
  },
};

export { Constants };